import React from "react";
import { Helmet } from "react-helmet-async";
import seoData from "../../assets/data/seo.json";

const TermsnConditions = () => {
  const seo = seoData["terms-conditions"] || {};
  const { title, description, keywords, canonical } = seo;

  return (
    <div className="bg-white min-h-screen">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {keywords && <meta name="keywords" content={keywords} />}
        {canonical && <link rel="canonical" href={canonical} />}
      </Helmet>

      <section className="py-20 bg-gray-50 border-b border-gray-100">
        <div className="container mx-auto px-6 text-center">
          <h1 className="font-bold text-gray-900 uppercase tracking-tight text-[28px] md:text-[50px] lg:text-[72px]">Terms & Conditions</h1>
          <p className="mt-4 text-gray-500 max-w-2xl mx-auto font-medium text-[12px] md:text-[14px] lg:text-[16px]">Agreement for clients and users</p>
        </div>
      </section>

      <section className="py-20 container mx-auto px-6 max-w-4xl">
        <div className="prose prose-red max-w-none text-gray-600 space-y-8 font-medium">
          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">1. Use of the Site</h2>
            <p>By accessing jettyestates.com, you agree to these Terms and Conditions and our Privacy Policy. The content on this site is provided for general informational purposes to assist users in locating luxury residential listings and details of properties.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">2. Property Inquiries & Requests</h2>
            <p>All inquiries submitted through our contact forms or account portals must contain truthful, accurate information. Requesting a property viewing or submitting a custom search form does not create an exclusive brokerage agreement unless explicitly signed in a separate agency agreement.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">3. Intellectual Property</h2>
            <p>The Jetty Estates name, logos, branding guidelines, site design, and listing details (including high-resolution photographs, renders, and text descriptions) are the exclusive property of Jetty Estates or its affiliate partners. They may not be scraped, copied, or reproduced for commercial listings without express permission.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">4. Limitation of Liability</h2>
            <p>While we make reasonable efforts to display current properties, Jetty Estates is not liable for errors in listing details, sudden changes in property availability, or server downtime.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">5. Governing Law</h2>
            <p>These terms are governed by the laws of the State of California, United States. Any disputes arising from the use of this website will be subject to the exclusive jurisdiction of the state and federal courts in Los Angeles County, California.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsnConditions;